import type { InjectionKey, Ref } from 'vue';
import type { TabData } from '@hypercodestudio/basler-components';

export const pdpActiveTabIdKey: InjectionKey<Ref<string>> =
  Symbol('pdpActiveTabId');

/**
 * Reactive id of the currently selected PDP tab (`TabPanel` `uid` / `computedId`).
 */
export function usePdpActiveTabId(): Ref<string> {
  return inject(pdpActiveTabIdKey, ref(''));
}

export function useIsPdpTabActive(tabId: string) {
  const activeTabId = usePdpActiveTabId();
  return computed(() => activeTabId.value === tabId);
}

export function providePdpActiveTabId() {
  const activeTabId = ref('');

  provide(pdpActiveTabIdKey, activeTabId);

  function setActivePdpTab(selectedTab: TabData): void {
    activeTabId.value = selectedTab.computedId;
  }

  return { activeTabId, setActivePdpTab };
}
